import { Chat } from 'components';
import useFetch from 'helpers/hooks/useFetch';
import useUser from 'helpers/hooks/useUser';
import { ChatTable, SparePartsChatTable } from 'models/repaircenter/detailsRma';
import { UserRole } from 'models/user/sso';
import { useEffect, useState } from 'react';
import { SPARE_PARTS } from 'resources';
import 'styles/repaircenter.scss';
import { downloadOrderFile, uploadFileSpare } from 'resources/api/spareParts_api';

type SparePartsChatType = {
    orderId?: number;
    company?: any;
};

function SparePartsChat({ orderId, company }: SparePartsChatType) {
    const [enable, setEnable] = useState<boolean>(true);
    const [messages, loadMessages, loading, updateMessages] = useFetch<{ sparePartsId: number; roleId: number }, ChatTable[]>({
        url: SPARE_PARTS.getAllMessages
    });
    const { user } = useUser();

    const [, addMessage] = useFetch<SparePartsChatTable, ChatTable>({
        url: SPARE_PARTS.chatAddMessage,
        method: 'POST'
    });

    useEffect(() => {
        if (orderId != undefined) loadMessages({ sparePartsId: orderId, roleId: parseInt(user?.role!) });
    }, [orderId]);

    return (
        <Chat
            loading={loading}
            onSend={async (message, enabled) => {
                await addMessage(
                    {
                        message,
                        orderId: orderId!,
                        userName: user?.name! ?? '',
                        itWasReadByAdmin: [UserRole.ADMIN, UserRole.SUPERADMIN].includes(user?.role!) ? true : false,
                        itWasReadByCustomer: [UserRole.CLIENT, UserRole.CLIENTADMIN].includes(user?.role!) ? true : false,
                        ssoId: user?.ssoid!,
                        companyId: user?.company!,
                        roleId: parseInt(user?.role!),
                        enable: enabled ?? true
                    },
                    current => {
                        if (!!current.data) {
                            updateMessages(old => [...old, current.data as ChatTable]);
                        }
                    }
                );
            }}
            messages={messages?.data ?? []}
            companies={company}
            chatId={orderId ?? 0}
            onUploadFile={async file => uploadFileSpare('CHAT_IMAGE', file, orderId!)}
            onDownloadFile={(fileNameOrId, downloadName) => downloadOrderFile(Number(fileNameOrId), downloadName ?? '')}
        />
    );
}
export default SparePartsChat;